module.exports = __webpack_public_path__ + "img/5.55334575.png";